import dota2KillIcon from 'app/icons/dota2_kill.svg';
import dota2GoldIcon from 'app/icons/dota2_gold.svg';
import { getPlayerBaseFromPlayerStat, getSortedPlayers } from 'app/utils/entities/match_data';

const getDota2PlayerStatsLines = (
  data: PlayersStatsBlockMatch
): PlayerStatsLines<StatPlayerDota2>[] => {
  const opponent1Stats = getSortedPlayers(data?.opponents.at(0)) as StatPlayerDota2[];
  const opponent2Stats = getSortedPlayers(data?.opponents.at(1)) as StatPlayerDota2[];

  // Sort properties in this array by wanted display order
  const properties: StatProperties<StatPlayerDota2>[] = [
    { name: 'kills', highlighted: 'max', Icon: dota2KillIcon },
    {
      name: 'gold_percentage',
      highlighted: 'max',
      Icon: dota2GoldIcon,
      displayFunction: value => `${Math.round(value)}%`
    },
    {
      name: 'last_hits',
      highlighted: 'max',
      displayFunction: value => Math.round(value).toString()
    },
    { name: 'camps_stacked', highlighted: 'max' },
    { name: 'most_picked', display: 'hero' }
  ];

  return Array(5)
    .fill(null)
    .map((_, index) => ({
      team1Player: getPlayerBaseFromPlayerStat(opponent1Stats[index]),
      team2Player: getPlayerBaseFromPlayerStat(opponent2Stats[index]),
      stats: properties.map(property => ({
        ...property,
        team1Value: opponent1Stats?.[index]?.[property.name],
        team2Value: opponent2Stats?.[index]?.[property.name]
      }))
    }));
};

export { getDota2PlayerStatsLines };
